import $ from 'jquery'

//
// var mySwiper = new Swiper('.swiper-container', { /* ... */ });
//
let obj_selector;
let obj_popup_selector;

var swiperImageSlider;
var swiperImageSliderPopup;

var $sliderGallery;
var $sliderGalleryPopup;


var sliders = [];

function initSwiper2() {

    // //console.log("event");
    // $(document).ready(function () {

    // $.each([".component-image-slider-container"], function (i, l) {
    //     // alert("Index #" + i + ": " + l);

    //     const id = $(l).attr("data-slider-id");
    //     initImageSliders(id)
    // });


    // initImageSliders2()

    $(document).on('pub:popup:vendors', function (event, device) {
        // //console.log(event);

        // //console.log(event.parent().attr('data-swiper-slide-index'));
        //             //console.log('trigger swiper vendor');
        // swiperImageSliderPopup.activeIndex = swiperImageSlider.activeIndex;


    });


    // });


}


// function initImageSliders(i) {

//     var button_selector = '.image-slider-button-' + i;

//     var global_obj_selector = '.component-image-slider-container[data-slider-id="' + i + '"]';

//     obj_selector = '.main ' + global_obj_selector;
//     obj_popup_selector = '.publisher-popups__popup ' + global_obj_selector;


//     let params = {
//         // Optional parameters
//         speed: 600,
//         spaceBetween: 0,
//         direction: 'horizontal',
//         loop: true,
//         updateOnWindowResize: true,
//         watchOverflow: true,
//         // centeredSlides: true,
//         threshold: 10,
//         resistanceRatio: 0.85,

//         // slideToClickedSlide: true,

//         freeModeSticky: true,
//         // clickable: true,

//         // navigation: {
//         //     nextEl: button_selector + '.swiper-button-next',
//         //     prevEl: button_selector + '.swiper-button-prev',
//         // },

//         breakpoints: {
//             // when window width is >= 320px
//             320: {
//                 slidesPerView: 1,
//                 spaceBetween: 0
//             },
//             // when window width is >= 480px
//             480: {
//                 slidesPerView: 2,
//                 spaceBetween: 0
//             },
//             // when window width is >= 640px
//             1024: {
//                 slidesPerView: 3,
//                 spaceBetween: 0
//             },
//             // when window width is >= 640px
//             1440: {
//                 slidesPerView: 4,
//                 spaceBetween: 0
//             }
//         }
//     };

//     swiperImageSlider = new Swiper(obj_selector, params)

//     swiperImageSlider.on('click', function () {
//         // //console.log($(obj_popup_selector));


//         if (this.clickedSlide) {
//             var $sw = swiperImageSliderPopup;
//             //console.log($sw);
//             setTimeout(function () {
//                 $sw.slideTo(6, 5000);
//             }, 10);
//             swiperImageSliderPopup.activeIndex = swiperImageSlider.activeIndex;

//             $(document).trigger('open:popup', [this.el.getAttribute('data-slider-id'), this.activeIndex]);

//         }

//         //
//     });


//         swiperImageSlider.on('slideChange', function () {
//             //console.log('slide changed');
//             Swiper[1].slideTo(swiperImageSlider.activeIndex);
//         });

//         // popup slider

//         params['breakpoints'] = {
//             320: {
//                 slidesPerView: 1
//             },
//             480: {
//                 slidesPerView: 1
//             },
//             1024: {
//                 slidesPerView: 1
//             },
//             1440: {
//                 slidesPerView: 1
//             }
//         }
//         params['navigation'] = {
//             nextEl: button_selector + '.swiper-button-next',
//             prevEl: button_selector + '.swiper-button-prev',
//         }


//         params['height'] = '100%';

//         swiperImageSliderPopup = new Swiper(obj_popup_selector, params)


//         swiperImageSliderPopup.on('slideChange', function () {
//             //console.log('slide changed popup');
//             swiperImageSlider.slideTo(swiperImageSliderPopup.activeIndex);
//         });


//         // $('.swiper-button-prev').on('click', function (e) {
//         //     e.preventDefault()
//         //     swiperImageSliderPopup.swipePrev()
//         // })

//         // $('.swiper-button-next').on('click', function (e) {
//         //     e.preventDefault()
//         //     swiperImageSliderPopup.swipeNext()
//         // })


// }


function initImageSliders2() {


    $('.swiper-container').each(function (i, element) {


        // //console.log(element);

        var index = $(element).attr('data-slider-id');

        var button_selector = '.image-slider-button-' + index;


        var global_obj_selector = '.component-image-slider-container[data-slider-id="' + index + '"]';
        //
        var obj_main_selector = '.slider-main' + global_obj_selector;
        var obj_popup_selector = '.slider-popup' + global_obj_selector;
        //


        var args = {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 600,
            spaceBetween: 0,
            direction: 'horizontal',
            loop: true,
            updateOnWindowResize: true,
            watchOverflow: true,
            centeredSlides: true,
            threshold: 10,
            resistanceRatio: 0.85,
            freeModeSticky: true,
            clickable: true,
            simulateTouch: true,
            //
            navigation: {
                nextEl: button_selector + '.swiper-button-next',
                prevEl: button_selector + '.swiper-button-prev',
            },
            on: {
                // activeIndexChange: function () {
                //     var newIndex = this.clickedIndex;
                //     //console.log(this);




                // }
                // touchEnd: function () {

                //     // //console.log("newIndex");
                //     // slideSlider(index, this.clickedIndex)
                // },

                // click: function (event) {

                //     var newIndex = this.clickedIndex;
                //     //console.log(newIndex);
                //     // var custom_slider = swiperInstances[1];

                //     //
                //     // swiper.update();
                //     // var $invoker = $(e.relatedTarget);
                //     if (newIndex) {
                //         // this.slideTo(newIndex);
                //     }


                //     slideSlider(index, this.clickedIndex)
                //     // this.update();
                //     // this.clickedSlide
                // }
            }
            //
            // nextButton: button_selector + ' .swiper-button-next', // + index,
            // prevButton: button_selector + ' .swiper-button-prev', // + index,

        };







        args['on'] = {
            slideChange: function () {
                // var newIndex = this.activeIndex;
                // //console.log("popupSlider", this.activeIndex);





                // slideGallery(newIndex);
                // //console.log("mainSlider", sliders[1]['t']);
                // sliderGallery.slideTo(5,2000);
                // swiper.slideTo(index, speed, runCallbacks)

            }
        };


        args['breakpoints'] = {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 0
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 0
            }
        };

        // args['loop'] = false;
        // args['centeredSlides'] = false;

        // args['breakpoints'] = {
        //     320: { slidesPerView: 1 }, 480: { slidesPerView: 1 }, 1024: { slidesPerView: 1 }, 1440: { slidesPerView: 1 }
        // };
        //
        //
        // args['on'] = {};
        $sliderGalleryPopup = new Swiper(obj_popup_selector, args);
        sliders.push($sliderGalleryPopup);

        args['effect'] =  'slide',
        args['loop'] = true;
        args['centeredSlides'] = true;



        args['breakpoints'] = {
            320: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 0
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 0
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 0
            }
        };

        args['on'] = {
            slideChange: function () {
                var newIndex = this.clickedIndex;
                // //console.log(sliderPopup.activeIndex - 3);
                // //console.log(this.activeIndex - 3);

                //console.log("mainSlider", this.activeIndex);
                //console.log("popupSlider", this.activeIndex);
            },
            click: function () {
                //console.log("clicked: ", this.clickedIndex);
                if (this.clickedIndex) {
                    this.slideTo(this.clickedIndex);
                }
            }
        };

        $sliderGallery = new Swiper(obj_main_selector, args);
        sliders.push($sliderGallery);





        $sliderGallery.controller.control = $sliderGalleryPopup;
        $sliderGalleryPopup.controller.control = $sliderGallery;
    });

}

function slideGallery(index, clickedIndex) {

    // // //console.log("slideGallery", $sliderGallery);
    // sliders[0].slideTo(1, 1000);

    // var sliders_selector = '.component-image-slider-container[data-slider-id="' + index + '"]';

    // // $(sliders_selector).each(function (i, element) {
    // $(sliders).each(function (i, element) {

    //     //     // //console.log(      $(element).activeIndex)

    //     //         var $this = $(this);
    //     // // +++++++++++

    //     // this.slideTo(clickedIndex);

    //     //console.log($this)
    //     //     $this.swiper({


    //     //     })


    // })




    // MAIN SLIDER

    // $(".swiper-container").each(function (index, element) {
    //     var $this = $(this);
    //     // //console.log($this);

    //     $this.slidesPerView = 5;
    //     this.update()
    //     // $this({
    //     //     // your settings ...
    //     //     slidesPerView: 10
    //     // });
    // });






}


function slideSlider(index, clickedIndex) {
    var sliders_selector = '.component-image-slider-container[data-slider-id="' + index + '"]';

    // $(sliders_selector).each(function (i, element) {
    $(sliders).each(function (i, element) {

        //     // //console.log(      $(element).activeIndex)

        //         var $this = $(this);
        // // +++++++++++

        // this.slideTo(clickedIndex);

        //console.log($this)
        //     $this.swiper({


        //     })


    })




    // MAIN SLIDER

    $(".swiper-container").each(function (index, element) {
        var $this = $(this);
        // //console.log($this);

        $this.slidesPerView = 5;
        this.update()
        // $this({
        //     // your settings ...
        //     slidesPerView: 10
        // });
    });
}


function initTest() {


    var swiperInstances = {};
    var swiperIndex = 0;

    if ($(".slider-main-custom.swiper-container")[0]) {

        let autoplay = false;
        let loop = false;
        var el = $(".slider-main-custom.swiper-container")[0];
        var sliderCount = $(el).attr('data-slider-count');

        if (sliderCount > 1) {
            autoplay = {
                delay: 3000,
            };


            loop = true;
        }

        $(".slider-main-custom.swiper-container").each(function (index, element) {

            var sliderID = $(element).attr('data-slider-id');

            // custom slider
            var $this = $(this);
            $this.addClass("custom-slider-" + swiperIndex);
            $this.find(".swiper-button-prev").addClass("btn-prev-" + swiperIndex);
            $this.find(".swiper-button-next").addClass("btn-next-" + swiperIndex);


            /** INIT SLIDERS **/
            swiperInstances[swiperIndex] = new Swiper(".custom-slider-" + swiperIndex, {
                // your settings ...
                speed: 1000,
                spaceBetween: 0,
                direction: 'horizontal',
                slidesPerView: 1,
                loop: loop,
                autoplay: autoplay,
                updateOnWindowResize: true,
                threshold: 10,
                resistanceRatio: 0.85,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
                navigation: {
                    nextEl: ".btn-next-" + index,
                    prevEl: ".btn-prev-" + index
                }

            });


            swiperIndex++;


        });

        swiperInstances[0].update();

    }




    if ($(".slider-main.swiper-container")[0]) {
        $(".slider-main.swiper-container").each(function (index, element) {

            var sliderID = $(element).attr('data-slider-id');

            /** INIT SLIDERS **/
            swiperInstances[index] = new Swiper(".slider-main.slider-" + index, {
                speed: 600,
                spaceBetween: 0,
                direction: 'horizontal',
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 0
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 0
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 0
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 0
                    }
                },
                navigation: {
                    nextEl: ".btn-next-" + swiperIndex,
                    prevEl: ".btn-prev-" + swiperIndex
                },
            });

            swiperIndex++;
            swiperInstances[swiperIndex] = new Swiper(".popup-slider-" + swiperIndex, {
                slidesPerView: 1,
                speed: 600,
                spaceBetween: 0,
                direction: 'horizontal',
                navigation: {
                    nextEl: ".btn-next-" + swiperIndex,
                    prevEl: ".btn-prev-" + swiperIndex,
                },
            });


            swiperIndex++;

        });
        swiperInstances[0].update();

    }

}


function initSwiper() {

    $(document).ready(function () {

        // MAIN SLIDER
        if ($('body').hasClass('page-template-template-frontpage')) {

            initTest()

        } else {



            // initSwiper2()

        }






        initImageSliders2()
        // reinitSwiper()

        // setTimeout(function () {
        //         slideSlider(6, 5000);
        //     }, 4000);
        // //console.log('initSWiper');

        //
        // $(document).on('pub:viewport', function (event, device) {
        //
        //     reinitSwiper()
        // });

    });


}

function reinitSwiper() {
    //
    // var len = sliders.length - 1;
    //
    // sliders[len][1].params.slidesPerView = 1;
    // sliders[len][1].params.spaceBetween = 5;

    // sliders[len][1].update()

}


export default initSwiper;